import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import webBanner from "../public/images/page_banner/green-habitants_web.png";
import mobBanner from "../public/images/page_banner/green-habitants_mob.png";
import Image from "next/image";
import GreenForm from "@/components/Greenhabitants/GreenForm";
import axios from "axios";
import qs from "qs";
import Seo from "@/components/seo/Seo";

const Greenhabitants = ({ data }) => {
  const [toggle, setToggle] = useState(false);
  const seo = data?.attributes?.seo;

  return (
    <>
      <Seo seo={seo} />
      <section
        id="carouselExampleDark"
        className="carousel carousel-dark slide"
      >
        <div className="carousel-inner">
          <div className="carousel-item active" data-bs-interval="10000">
            <Image
              src={webBanner}
              className="d-none d-md-block  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />

            <Image
              src={mobBanner}
              className="d-block d-md-none  w-100"
              alt="banner"
              style={{ width: "auto", height: "auto" }}
            />
          </div>
        </div>
      </section>
      <section className="sec-padd">
        <button
          onClick={() => setToggle(!toggle)}
          className="btnheading text-center"
        >
          Click here to Register as a Green Habitant
        </button>
        {toggle && (
          <Row className="justify-content-center">
            <Col md={6}>
              <div className="darkform mt-4 px-2">
                <GreenForm />
              </div>
            </Col>
          </Row>
        )}
        <Container>
          <div className="inner_text mt-3 mt-md-5">
            <p>
              New Kolkata is welcoming its buyers to be a part of their Green
              Habitants club to facilitate a healthy and eco-friendly living
              standard within New Kolkata. This housing project is pre-certified
              by the Indian Green Building Council (IGBC), whose objective is to
              provide a sustainable living environment for the residents of
              India.
            </p>
            <p>
              New Kolkata is all set to provide Green Affordable Housing for the
              lower income strata of society. It is an effective step which will
              provide the residents an eco-friendly and raise in their current
              standard of living. This measure will aid lower energy and water
              consumption along with better sanitation and hygiene. Plus, the
              potential residents will experience better ventilation and light
              in the houses along backed up by a lower consumption of fuel
              during transit to reduce pollution. Hence, join hands with the
              Green Habitants to welcome a healthy lifestyle and sustainable
              future.
            </p>
          </div>
        </Container>
      </section>
      <section className="main-section gallery-section sec-padd-bot">
        <div className="container">
          <div className="residency-wrapper gallery-wrapper habitant-warpper">
            <figure className="residency-box gallery-box">
              <a href="/plant-tree">
                <div className="residency-img">
                  <Image
                    fill
                    className="image"
                    alt="   Plant a Tree Event - 11th March 2018"
                    src="/images/green_habitant/gb_tab_img.png"
                  />
                </div>
                <figcaption className="gallery-title">
                  Plant a Tree Event - 11th March 2018
                </figcaption>
              </a>
            </figure>
            <figure className="residency-box gallery-box">
              <a href="/earth-day">
                <div className="residency-img">
                  <Image
                    fill
                    className="image"
                    alt="Earth Day Event - 22nd April 2018"
                    src="/images/green_habitant/gb_img01.jpg"
                  />
                </div>
                <figcaption className="gallery-title">
                  Earth Day Event - 22nd April 2018
                </figcaption>
              </a>
            </figure>
            <figure className="residency-box gallery-box">
              <a href="/green-habitants/water-affair">
                <div className="residency-img">
                  <Image
                    fill
                    className="image"
                    alt="Take The Pledge - 05th June 2018"
                    src="/images/green_habitant/Pledge_Environment_Day_Final.png"
                  />
                </div>
                <figcaption className="gallery-title">
                  Take The Pledge - 05th June 2018
                </figcaption>
              </a>
            </figure>
            <figure className="residency-box gallery-box">
              <a href="/gallery/water-affairs">
                <div className="residency-img">
                  <Image
                    fill
                    className="image"
                    alt="The Water Affair"
                    src="/images/green_habitant/IMG_0489-min.jpg"
                  />
                </div>
                <figcaption className="gallery-title">
                  The Water Affair
                </figcaption>
              </a>
            </figure>
          </div>
        </div>
      </section>
    </>
  );
};

export default Greenhabitants;
export async function getServerSideProps() {
  try {
    const query = {
      populate: ["*", "seo", "seo.metaImage", "seo.schema"],
    };

    /** If we are loading projects from anywhere other than the home page, then we load the configuration information also. */

    const queryString = qs.stringify(query, {
      encodeValuesOnly: true,
    });

    const endpoint = `${process.env.NEXT_PUBLIC_BACKEND_API_URL}/api/green-habitant?${queryString}`;
    // console.log(`Final url: ${endpoint}`);

    const response = await axios.get(endpoint);
    const data = response.data.data;
    // Pass data to the page via props
    return {
      props: { data },
    };
  } catch (error) {
    console.log("Error", error);
  }
}
